import { Pipe, PipeTransform } from '@angular/core';
import { DictStorageService } from '../storages/dict-storage.service';
import { of, Observable } from 'rxjs';

@Pipe({
  name: 'dictName'
})
export class DictNamePipe implements PipeTransform {

  constructor(private dictStorageService: DictStorageService) {

  }

  transform(value: any, args?: any): Observable<string> {
    if (!value || !args) {
      return of('');
    }

    return this.dictStorageService.getName(value, args);
  }
}
